export default {
  // Common
  NODE_JS: '>= 16',
  YARN: '>= 1.10.x',
  NPM: '>= 4.x',
  RUBY: '>= 2.6.10',
  JAVA: '>= 11',
  // Android
  ANDROID_SDK: '>= 33.x',
  ANDROID_NDK: '>= 23.x',
  // iOS
  XCODE: '>= 12.x',
  COCOAPODS: '>= 1.10.0',
};
